const constants={
    ENC_KEY:"KAJSDISHANTKAPOORsjdk12"
}

export default constants;